var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "text-center",
          attrs: {
            cols: "12"
          }
        },
        [
          _c("v-img", {
            staticClass: "ma-auto",
            attrs: {
              src: _vm.imageUrl,
              contain: "",
              "max-width": "300",
              "max-height": "350"
            }
          }),
          _c(
            "a",
            {
              attrs: {
                href: _vm.imageUrl,
                target: "_blank"
              }
            },
            [_vm._v("View Full (Size: " + _vm._s(_vm.size) + ")")]
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pb-0",
          attrs: {
            cols: "12",
            md: "8",
            "offset-md": "2"
          }
        },
        [
          _c("v-textarea", {
            staticClass: "mb-3",
            attrs: {
              outlined: "",
              "hide-details": "",
              label: "Your Affiliate Code",
              readonly: "",
              rows: "3",
              value: _vm.code
            }
          }),
          _c("v-select", {
            attrs: {
              outlined: "",
              dense: "",
              label: "Campaign Code",
              items: _vm.campaigns
            },
            model: {
              value: _vm.campaign,
              callback: function callback($$v) {
                _vm.campaign = $$v
              },
              expression: "campaign"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pt-0",
          attrs: {
            cols: "12"
          }
        },
        [_c("hr")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }